export default __webpack_public_path__ + "static/media/ruby.97331365.png";